import React from 'react';
import ChannelTypeForm from '../ChannelTypeForm'

import './channelEdit.css';

export function ChannelTypeEdit() {
    return <ChannelTypeForm isEdit={true} />;
}
